export default __webpack_public_path__ + "static/media/je.0a58cb8a.jpg";